import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy} from '@angular/core';
import {Donation} from "../donation/donation";

@Component({
  selector: 'donation-status',
  templateUrl: './output.status.component.html'
})
export class StatusComponent implements OnChanges, OnDestroy {
  /**
   * All posible status
   */
  public static readonly OK = "ok";
  public static readonly CANCELED = "canceled";
  public static readonly REDIRECT = "redirect";
  public static readonly IFRAME = "iframe";
  public static readonly WAITING = "waiting";
  public static readonly ERROR = "error";

  /**
   * Timeout for showing the reset button for the status
   */
  public static readonly HINT_TIMEOUT_SECONDS: number = 4;

  /**
   * The status that should be shown
   */
  @Input() status: string;

  /**
   * message that should be visible for the user
   */
  @Input() message: string;

  /**
   * current donation
   */
  @Input() donation: Donation = null;

  /**
   * Eventemitter if the status changes
   */
  @Output() statusChange: EventEmitter<string> = new EventEmitter<string>();

  /**
   * toggle for showing, hiding the reset hint
   * @private
   */
  private hintCounter: any;

  /**
   * toggle for showing the reset button for redirect transactions
   */
  showCancelHint = false;

  /**
   * statur values, as local variable to be used inside the template
   */
  statusWaiting = StatusComponent.WAITING;
  statusRedirect = StatusComponent.REDIRECT;
  statusCanceled = StatusComponent.CANCELED;
  statusError = StatusComponent.ERROR;

  /**
   * @inheritDoc
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty("status") && changes.status.firstChange === false && changes.status.currentValue === StatusComponent.REDIRECT) {
      this.hintCounter = setTimeout(() => this.showCancelHint = true, StatusComponent.HINT_TIMEOUT_SECONDS * 1000);
    }
  }

  /**
   * @inheritDoc
   */
  ngOnDestroy(): void {
    clearTimeout(this.hintCounter);
  }

  /**
   * Returns the current URL of the window.
   */
  currentUrl(): string {
    return document.location.href;
  }

  /**
   * Reset the status to start the donation again.
   */
  resetStatus(): void {
    this.status = StatusComponent.OK;
    this.statusChange.emit(this.status);
  }

}
